import {
    mdiSchoolOutline,
    mdiMapMarker,
    mdiClockTimeFourOutline,
    mdiCalendarMonth,
    mdiCash,
} from "@mdi/js"
import dates from "@/mixins/dates"
import mappingService from "@/services/mapping.service"
import { APPRENTICESHIP } from "@/enums/jobtypes"

export default {
    mixins: [dates],
    props: {
        job: {
            type: Object,
            required: true,
        },
    },
    icons: {
        mdiSchoolOutline,
        mdiMapMarker,
        mdiClockTimeFourOutline,
        mdiCalendarMonth,
        mdiCash,
    },
    computed: {
        isApprenticeship() {
            return this.job.type_id === APPRENTICESHIP
        },
        graduation() {
            const graduation = mappingService.mapGraduationShort(
                this.job.required_graduation
            )
            if (graduation === "Für jeden frei") return graduation
            return `mind. ${graduation}`
        },
        businessAddress() {
            return this.job.business_site?.address
        },
        salaries() {
            return this.job.apprenticeship?.salaries ?? []
        },
        duration() {
            if (!this.job.duration) return
            return mappingService.mapJobDurationType(this.job)
        },
        detailBlocks() {
            const blocks = []
            // graduation
            blocks.push({
                id: "graduation",
                prefix: "Wer",
                text: this.graduation,
                icon: this.icons.mdiSchoolOutline,
            })
            // location
            if (this.businessAddress)
                blocks.push({
                    id: "location",
                    prefix: "Wo",
                    text: this.businessAddress.street.concat(
                        ", ",
                        this.businessAddress.city
                    ),
                    icon: this.icons.mdiMapMarker,
                })
            // duration
            if (this.duration)
                blocks.push({
                    id: "duration",
                    prefix: "Dauer",
                    text: this.duration,
                    icon: this.icons.mdiClockTimeFourOutline,
                })
            // starting date
            if (this.isApprenticeship && this.job.date_of_start)
                blocks.push({
                    id: "starting-date",
                    prefix: "Beginn",
                    text: this.toDate(this.job.date_of_start),
                    icon: this.icons.mdiCalendarMonth,
                })
            // salary
            if (this.isApprenticeship) {
                if (this.salaries.length > 0) {
                    blocks.push({
                        id: "salary",
                        prefix: "Gehalt",
                        text: this.getSalaryString(this.salaries),
                        icon: this.icons.mdiCash,
                    })
                } else if (this.job.estimated_salary) {
                    blocks.push({
                        id: "salary",
                        prefix: "Geschätztes Gehalt",
                        text: this.job.estimated_salary.avg + "€",
                        icon: this.icons.mdiCash,
                    })
                }
            }
            return blocks
        },
    },
    methods: {
        /** Returns formatted salary string,
         * "500€" for 1 salary
         * "500€ - 1000€" for 2 salaries
         * "Jahr 1: 500€
         *  Jahr 2: 1000€
         *  Jahr 3: 1500€" for 3+ salaries (with newlines)
         */
        getSalaryString(salaries) {
            if (!salaries) return
            if (salaries.length === 1) return salaries[0] + "€"
            let salaryString = ""
            for (let i = 0; i < salaries.length; i++) {
                salaryString += `Jahr ${i + 1}: ${salaries[i]}€`
                if (i !== salaries.length - 1) salaryString += "\n"
            }
            return salaryString
        },
    },
}
